import apiClient from './apiClient';

const unwrap = async (request) => (await request).data.data;
const supportMirrorService = {
  start: (userId) => unwrap(apiClient.post('/support-mirror', { userId })),
  current: () => unwrap(apiClient.get('/support-mirror/current')),
  approve: (id, tabId) => unwrap(apiClient.post(`/support-mirror/${id}/approve`, { tabId })),
  publish: (id, tabId, frame) => unwrap(apiClient.put(`/support-mirror/${id}/frame`, { tabId, ...(frame ? { frame } : {}) })),
  view: (id, after = -1) => unwrap(apiClient.get(`/support-mirror/${id}`, { params: { after } })),
  stop: (id) => unwrap(apiClient.post(`/support-mirror/${id}/stop`)),
};
export default supportMirrorService;
